import React, { useEffect, useRef, useState } from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveIcon from "@mui/icons-material/Save";
import Swal from "sweetalert2";
import { LoaderScreen } from '../../../components/LoaderScreen';
import { useHistory } from "react-router-dom";
import { FiltroObjetivosMensuales } from "./FiltroObjetivosMensuales";
import { ObjetivosSemanalesTabla } from "./ObjetivosSemanalesTabla";
import { ObjetivosSemanalesCRMService, extraerMensajeError } from "./ObjetivosSemanalesCRMService";

const CRM_ObjetivosMainScreen = () => {
    const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
    const history = useHistory();
    const tablaRef = useRef(null);

    const [filtro, setFiltro] = useState({
        ejercicio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
    });
    const [datos, setDatos] = useState([]);
    // Refleja guardando/generando de ObjetivosSemanalesTabla para los botones del header
    const [acciones, setAcciones] = useState({ guardando: false, generando: false });

    const cargarListado = (ejercicio, periodo) => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        ObjetivosSemanalesCRMService.listado(ejercicio, periodo)
            .then((result) => {
                setDatos(Array.isArray(result) ? result : []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setDatos([]);
                Swal.fire("OBJETIVOS MENSUALES", extraerMensajeError(error), "error");
            });
    };

    useEffect(() => {
        cargarListado(filtro.ejercicio, filtro.mes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCargar = (ejercicio, mes) => {
        setFiltro({ ejercicio, mes });
        cargarListado(ejercicio, mes);
    };

    const onGuardar = (detalle, comentarios) => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        return ObjetivosSemanalesCRMService.guardar({ ejercicio: filtro.ejercicio, periodo: filtro.mes, detalle, comentarios })
            .then(async () => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                await Swal.fire("OBJETIVOS MENSUALES", "Objetivos guardados con éxito", "success");
                cargarListado(filtro.ejercicio, filtro.mes);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("OBJETIVOS MENSUALES", extraerMensajeError(error), "error");
            });
    };

    const onGenerarSemanas = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        return ObjetivosSemanalesCRMService.generarSemanas(filtro.ejercicio)
            .then(async (result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                await Swal.fire("OBJETIVOS MENSUALES", result?.mensaje || "Registradas con éxito", "success");
                cargarListado(filtro.ejercicio, filtro.mes);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("OBJETIVOS MENSUALES", extraerMensajeError(error), "error");
            });
    };

    // Los botones viven en el header; disparan las acciones reales dentro de ObjetivosSemanalesTabla
    // (ahí vive el estado de captura/edición) vía ref.
    const onClickGenerarSemanas = () => tablaRef.current?.generarSemanas();
    const onClickGuardar = () => tablaRef.current?.guardar();

    return (
        <div className="crm-main-screen">
            <LoaderScreen loader={loader} />
            <div className="crm-body">
                <div className="crm-page rca-screen">
                    <div className="crm-module">
                        <div className="crm-module-head">
                            <div className="crm-head-grid">
                                <div className="crm-head-left">
                                    <button className="crm-btn-regresar" onClick={() => history.goBack()} aria-label="Regresar">
                                        <ArrowBackIcon /> <span className="crm-btn-label">Regresar</span>
                                    </button>
                                    <FiltroObjetivosMensuales onCargar={onCargar} ejercicio={filtro.ejercicio} mes={filtro.mes} />
                                </div>
                                <div className="crm-head-center">
                                    <p className="crm-module-subtitle">Capturas</p>
                                    <h1 className="crm-module-title">OBJETIVOS MENSUALES</h1>
                                </div>
                                <div className="crm-head-right">
                                    <button
                                        className="crmcs-btn-excel"
                                        onClick={onClickGenerarSemanas}
                                        disabled={acciones.generando}
                                        aria-label={acciones.generando ? "Generando..." : "Generar semanas"}
                                    >
                                        <AddCircleIcon /> <span className="crm-btn-label">{acciones.generando ? "Generando..." : "Generar semanas"}</span>
                                    </button>
                                    <button
                                        className="crmcs-btn-excel"
                                        onClick={onClickGuardar}
                                        disabled={acciones.guardando}
                                        aria-label={acciones.guardando ? "Guardando..." : "Guardar objetivos"}
                                    >
                                        <SaveIcon /> <span className="crm-btn-label">{acciones.guardando ? "Guardando..." : "Guardar objetivos"}</span>
                                    </button>
                                </div>
                            </div>
                            <div className="crm-head-divider">
                                <div className="crm-head-divider-dot" />
                            </div>
                        </div>

                        <div className="crm-home-wrapper rca-wrapper scroll">
                            <ObjetivosSemanalesTabla
                                ref={tablaRef}
                                datos={datos}
                                cargando={loader.mostrar}
                                ejercicio={filtro.ejercicio}
                                periodo={filtro.mes}
                                onGuardar={onGuardar}
                                onGenerarSemanas={onGenerarSemanas}
                                onEstadoAccionesChange={setAcciones}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CRM_ObjetivosMainScreen
